import { Coin } from "./coin"

export interface VerifyAndEarnPromotion {
    type: string;
    promotionEnabled: boolean;
    status: PromotionStatus;
    endDate: string;
    minDeposit: Coin;
    reward: Coin;
}

export interface InviteAndEarnPromotion {
   firstName: string;
}

export interface AllPromoations {
    verifyAndEarn: VerifyAndEarnPromotion;
    inviteAndEarn: InviteAndEarnPromotion;
}

export interface InviteAndEarnPromotionInput {
    referralId: string
}

export interface AllPromoationsInput {
    inviteAndEarn: InviteAndEarnPromotionInput;
}

export enum PromotionStatus {
    ENABLED = 'ENABLED',
    DISABLED = 'DISABLED',
    CONSUMED = 'CONSUMED'
}